import type { OwaDate } from '../../schema';
import { GlobalCalendarLocale, GlobalCalendarType } from '../../intl/globalCalendarLocale';
import isGlobalCalendarDateOnly from '../../intl/isGlobalCalendarDateOnly';
import getIntlMonthBase from './base/getIntlMonthBase';
import getIntlMonthHijri from './hijri/getIntlMonthHijri';

export default function getIntlMonth(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit' | 'short' | 'long'
): string {
    if (isGlobalCalendarDateOnly(locale)) {
        return '';
    }

    if (locale.calendarType === GlobalCalendarType.Hijri) {
        return getIntlMonthHijri(date, locale, format);
    }

    return getIntlMonthBase(date, locale, format);
}
